import React from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { useCustomName } from "hooks"
import { DEPARTMENT_KEY } from "utils/customNameHelpers"
import { getFacilityIdMap } from "reduxSlices/facilitiesSlice"
import ItemRow from "shared/ItemRow"
import CircularIconButton from "shared/buttons/CircularIconButton"
import GroupSearchGroupMemberList from "shared/searches/SearchSelectedGroup/GroupSearchGroupMemberList"
import AccessLevelIdentifier from "./AccessLevelIdentifier"

const DepartmentGranteeList = ({
  departments, formSubmissionSlug, updateAccessGranteeLists, deleteFormSubmissionGrant, isDisabled,
}) => {
  const facilityIdMap = useSelector(getFacilityIdMap)

  const { name: departmentName } = useCustomName(DEPARTMENT_KEY)

  if (!departments.length) {
    return <span>No {departmentName} with Grants</span>
  }

  return (
    departments.map(({
      grantee: department, formGrant, categoryGrant, formSubmissionGrant,
    }) => {
      const grantIsDeletable = !isDisabled && !!formSubmissionGrant
      const facilityName = facilityIdMap[department.facilityId]?.name
      const departmentLabel = facilityName ? `${facilityName}: ${department.name}` : department.name

      return (
        <ItemRow
          key={`department-item-row-${department.id}`}
          collapsable
          itemRowHeaderContentClassName="item-row-header-content-submission-access"
          itemRowHeaderContent={(
            <>
              <span className="font-semibold">{departmentLabel}</span>
              <AccessLevelIdentifier
                className={
                  grantIsDeletable
                    ? "item-row-header-content-breaker-double"
                    : "item-row-header-content-breaker"
                }
                formSubmissionSlug={formSubmissionSlug}
                formSubmissionGrant={formSubmissionGrant}
                formGrant={formGrant}
                categoryGrant={categoryGrant}
                updateAccessGranteeLists={updateAccessGranteeLists}
                granteeType="Department"
                granteeId={department.id}
                isDisabled={isDisabled}
                selectLabel={`select access level for ${departmentLabel}`}
              />
            </>
          )}
          itemRowHeaderControls={(
            <>
              {
                !isDisabled && !!formSubmissionGrant && (
                  <CircularIconButton icon="close" onClick={deleteFormSubmissionGrant(formSubmissionGrant?.id)} ariaLabel={`delete ${departmentLabel} access grant`} />
                )
              }
            </>
          )}
          itemRowBody={
            <GroupSearchGroupMemberList members={department.members} />
          }
        />
      )
    })
  )
}

DepartmentGranteeList.propTypes = {
  departments: types.arrayOf(types.object).isRequired,
  formSubmissionSlug: types.string.isRequired,
  updateAccessGranteeLists: types.func.isRequired,
  deleteFormSubmissionGrant: types.func.isRequired,
  isDisabled: types.bool.isRequired,
}

export default DepartmentGranteeList
